/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataHtmlPageConfigInfoRespVo } from './PageDataHtmlPageConfigInfoRespVo';
import {
    PageDataHtmlPageConfigInfoRespVoFromJSON,
    PageDataHtmlPageConfigInfoRespVoFromJSONTyped,
    PageDataHtmlPageConfigInfoRespVoToJSON,
    PageDataHtmlPageConfigInfoRespVoToJSONTyped,
} from './PageDataHtmlPageConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataHtmlPageConfigInfoRespVo
 */
export interface ResponsePageDataHtmlPageConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataHtmlPageConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataHtmlPageConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataHtmlPageConfigInfoRespVo}
     * @memberof ResponsePageDataHtmlPageConfigInfoRespVo
     */
    data?: PageDataHtmlPageConfigInfoRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataHtmlPageConfigInfoRespVo interface.
 */
export function instanceOfResponsePageDataHtmlPageConfigInfoRespVo(value: object): value is ResponsePageDataHtmlPageConfigInfoRespVo {
    return true;
}

export function ResponsePageDataHtmlPageConfigInfoRespVoFromJSON(json: any): ResponsePageDataHtmlPageConfigInfoRespVo {
    return ResponsePageDataHtmlPageConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataHtmlPageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataHtmlPageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataHtmlPageConfigInfoRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataHtmlPageConfigInfoRespVoToJSON(json: any): ResponsePageDataHtmlPageConfigInfoRespVo {
    return ResponsePageDataHtmlPageConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponsePageDataHtmlPageConfigInfoRespVoToJSONTyped(value?: ResponsePageDataHtmlPageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataHtmlPageConfigInfoRespVoToJSON(value['data']),
    };
}

